export const productImageUrl =
  'https://cdn.magicpatterns.com/uploads/jPFbxUTGS3G2KQ3zRAoGue/hf_20260825_233329_1b1257fc-c3e2-440c-b88d-d6cef1ee02d0.webp'

export const checkoutUrl = 'https://functional-ready.impultienda.ar/checkout'

export const price = {
  current: '$27',
  total: '$106',
  savings: '$79',
  bonusValue: '$87',
}
